import { render, staticRenderFns } from "./ReceiveCheckArchive.vue?vue&type=template&id=5ea7a0bb&"
import script from "./ReceiveCheckArchive.vue?vue&type=script&lang=js&"
export * from "./ReceiveCheckArchive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports